module.exports = __webpack_public_path__ + "static/media/slide2.d717e137.jpg";